import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SlickCarouselModule } from 'ngx-slick-carousel';

@Component({
  selector: 'app-policy-street-sme-services',
  standalone: true,
  imports: [CommonModule, SlickCarouselModule, TranslateModule],
  templateUrl: './policy-street-sme-services.component.html',
  styleUrl: './policy-street-sme-services.component.scss'
})
export class PolicyStreetSmeServicesComponent {
 slideConfig = {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        centerMode: false,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                    centerMode: false,
                    infinite: false,
                },
            },
        ],
    };
}
